export default __webpack_public_path__ + "static/media/57.5271745a.png";